import Vue from "vue";
import "./components/";
import axios from "axios";
import i18n from "./i18n";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

router.beforeEach((to, from, next) => {
  const lsToken = localStorage.getItem("access_token");
  if (lsToken !== null) {
    axios.get(store.state.chronosApi + "current-user", {
        headers: { Authorization: lsToken },
      })
      .then((response) => {
        if (!response.data.resource) {
          store.state.loggedIn = false;
        } else {
          store.state.loggedIn = true;
          store.state.user_is_client_type = response.data.resource.data.attributes.is_client_type;
          if(response.data.resource.data.attributes.image != null) store.state.loggedPicture = response.data.resource.data.attributes.image;

          store.state.loggedUsername = response.data.resource.data.attributes.name + ' ' + response.data.resource.data.attributes.paternal_surname + ' ' + response.data.resource.data.attributes.maternal_surname;
          store.state.loggedUserRole = [];
          response.data.resource.data.attributes.roles.forEach( x => {
              store.state.loggedUserRole.push({
                  id: x.attributes.id,
                  name: x.attributes.name
              })
          })
          store.state.loggedUserEmail = response.data.resource.data.attributes.email;
          store.state.loggedUserPermissions = [];
          
          store.state.language = response.data.resource.data.attributes.language_preferences;
          localStorage.setItem('language', store.state.language);

          store.state.theme = response.data.resource.data.attributes.theme_style;
          localStorage.setItem('theme', store.state.theme);

          vuetify.framework.theme.dark = (store.state.theme == 'dark' ? true : false);

          response.data.resource.data.attributes.roles[0].attributes.permissions.forEach( x => {
              store.state.loggedUserPermissions.push(x.attributes.name);
          });
          store.state.clients = response.data.resource.data.attributes.clients;
          
          if(response.data.resource.data.attributes.client != null && response.data.resource.data.attributes.client != undefined)
            store.state.clientUserIsCod = (response.data.resource.data.attributes.client.attributes.fulfillment == "cod" || response.data.resource.data.attributes.client.attributes.fulfillment == 'all') ? true : false;        
            store.state.clientShippingServices = response.data.resource.data.attributes.shipping_services;
            store.state.warehouseId = response.data.resource.data.attributes.warehouse.attributes.id;
            localStorage.setItem('warehouse_id', store.state.warehouseId);
            localStorage.setItem('warehouseName', response.data.resource.data.attributes.warehouse.attributes.name);
          }
        
        if (store.state.loggedIn) {
          if (store.state.user_is_client_type) {
            store.state.layout = "customerDashboard";
            document.title = to.meta.title;
            next();
          }
          else{
            store.state.layout = "dashboard";
            document.title = to.meta.title;
            next();
          }
        } else {
          if (to.meta.auth) {
            store.state.layout = "login";
            document.title = "Chronos - Inicio de sesión";
            next("login");
          } else {
            document.title = "Chronos - Inicio de sesión";
            store.state.layout = "login";
            next();
          }
        }
      })
      .catch((error) => {
        console.log(error);
        /* eslint-disable */
        // if (error.response.status == 401 || error.response.status == 500) {
          localStorage.removeItem("access_token");
          document.title = "Chronos - Inicio de sesión";
          store.state.layout = "login";
          next("login");
        // }
      });
  } else {
    if (to.meta.auth) {
      store.state.layout = "login";
      next("login");
    } else {
      store.state.layout = "login";
      next();
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
